import { Timestamp } from "firebase/firestore";
import { User } from "../interfaces/entities/user";
import { UserRoles } from "../enums/userRoles.enum";
import { simpleHash } from "../api/authApi";
import { tempPass } from "../utils/config";

export const defaultUser = (ownerId: string, role: UserRoles): User => ({
    id: "",
    role,

    firstName: "",
    lastName: "",
    empNo: "",
    address: "",
    contact: "",
    nic: "",
    email: "",
    password: simpleHash(tempPass), // Default temporary password
    companyId: '',
    branchId: '',
    image: "",

    createdAt: Timestamp.fromDate(new Date()),
    updatedAt: Timestamp.fromDate(new Date()),

    enabled: true,
    ownerId
});

